import { normalizePersistedRecipients } from '../persistedRecipients';

export default (state: any) => {
  if (!state || typeof state !== 'object' || !state.recipients || typeof state.recipients !== 'object') {
    return state;
  }

  return {
    ...state,
    recipients: {
      ...state.recipients,
      recipients: normalizePersistedRecipients(state.recipients.recipients),
    },
  };
};
